export default __webpack_public_path__ + "static/media/Hariti & Panchika.8798b5f1.png";